import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChildren } from '@angular/core';
import { RendererComponent, updateReasons } from '../renderer/renderer.component';

@Component({
  selector: 'k-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.less'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class GalleryComponent implements OnInit {

  @Input() list = []
  @Input() showAnimation = true
  @Input() showSidebar
  @Input() showToolbar

  @Input() startIndex
  @Input() endIndex

  @Input() toggleSidebarTemplate:TemplateRef<any>|null = null

  @ViewChildren('renderer') renderer

  activeIndex:number = 0;

  opened:boolean = true

  colors = [
    '#33ddff', '#fa3253', '#34d1b7', '#ff007c', '#ff6037', '#ddff33',
    '#24b353', '#b83df5', '#66ff66', '#32b7fa', '#ffcc33', '#83e070',
    '#fafa37', '#5986b3', '#8c78f0', '#ff6a4d', '#f078f0', '#2a7dd1',
    '#b25050', '#cc3366', '#cc9933', '#aaf0d1', '#ff00cc', '#3df53d',
    '#fa32b7', '#fa7dbb', '#ff355e', '#f59331', '#3d3df5', '#733380',
  ];

  constructor(
    private cdr:ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.opened = this.showSidebar
    this.list.forEach((item,index)=>{
      item.annotationData.forEach((element,i) => {
        element.color = this.getColor(i)
      });
    })
 
  }

  update(){
    this.cdr.detectChanges()
    let result = this.renderer._results;
    
    for(let render of result){
     
         
      setTimeout(() => {
  
        (render as RendererComponent).rerender()
      }, 300);
        
   
    }
  }

  handleChangeActiveIndex(data){
 
    this.activeIndex = data
  }
  changeActiveIndexByDirection(gonext:boolean){
    if(gonext){
      this.activeIndex+=1;
    }else{
      this.activeIndex-=1;
    }
    /////////////////////////////////////////////
    if(this.activeIndex>this.endIndex){
      this.activeIndex = this.startIndex
    }else if(this.activeIndex<this.startIndex){
      this.activeIndex = this.endIndex
    }

  }

  handleOpenDrawer(value){
     
    this.opened = value;
    
    let result = this.renderer._results;
    console.log(this.list)
    for(let render of result){
     
         
      setTimeout(() => {
  
        (render as RendererComponent).rerender()
      }, 300);
        
   
    }
     
    
  }

  getColor(index){
    let target = (index+1)%30;
    let t = this.colors[target]
    console.log(t)
    return this.colors[target]
  }

}
